var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "modal-card" }, [
    _c("div", { staticClass: "modal-card-head centered-items" }, [
      _c("h2", { staticClass: "title" }, [
        _vm._v(
          " " +
            _vm._s(_vm.enduser.enduserCode + " - " + _vm.enduser.enduserName) +
            " "
        ),
      ]),
    ]),
    _c("section", { staticClass: "modal-card-body" }, [
      _c("span", { staticClass: "buttons" }, [
        _c(
          "button",
          {
            staticClass: "button is-warning is-outlined is-small",
            on: { click: _vm.close },
          },
          [
            _c("b-icon", { attrs: { icon: "chevron-left" } }),
            _c("span", [_vm._v(_vm._s(_vm.$t("global.back")))]),
          ],
          1
        ),
      ]),
      _c(
        "div",
        [
          _vm.enduser.closures && _vm.enduser.closures.length > 0
            ? _c("div", [
                _c("h2", { staticClass: "subtitle" }, [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.$t("pages.pickup_management.closures.closing_dates")
                      ) +
                      " "
                  ),
                ]),
                _c(
                  "div",
                  {
                    staticClass: "centered-items cards",
                    attrs: { id: "calendar-step-cd-screen" },
                  },
                  _vm._l(_vm.enduser.closures, function (closure) {
                    return _c(
                      "div",
                      { key: closure.id, staticClass: "card m-10" },
                      [
                        _c("b-button", {
                          staticClass: "is-small is-danger p-right",
                          attrs: { "icon-left": "trash" },
                          on: {
                            click: function ($event) {
                              return _vm.deleteClosure(closure.id)
                            },
                          },
                        }),
                        _c("div", { staticClass: "card-body p-10" }, [
                          _c(
                            "div",
                            { staticClass: "flex-column-center" },
                            [
                              _c("span", [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$t(
                                        "pages.pickup_management.closures.closed"
                                      )
                                    ) +
                                    " "
                                ),
                              ]),
                              _c("b-icon", {
                                attrs: { icon: "calendar", type: "is-dark" },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            [
                              _c(
                                "span",
                                { staticClass: "tag is-medium is-link" },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm
                                          .$dayjs(closure.startDate)
                                          .local()
                                          .format("DD/MM/YYYY")
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                              _c("b-icon", {
                                staticClass: "m-10",
                                attrs: {
                                  icon: "arrow-right",
                                  type: "is-primary",
                                },
                              }),
                              _c(
                                "span",
                                { staticClass: "tag is-medium is-link" },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm
                                          .$dayjs(closure.endDate)
                                          .local()
                                          .format("DD/MM/YYYY")
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c("span", {}, [
                            _vm._v(" " + _vm._s(closure.comment) + " "),
                          ]),
                        ]),
                      ],
                      1
                    )
                  }),
                  0
                ),
              ])
            : _vm._e(),
          _c("ValidationObserver", {
            ref: "observer",
            attrs: { tag: "form" },
            on: {
              submit: function ($event) {
                $event.preventDefault()
                return _vm.submit.apply(null, arguments)
              },
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ valid }) {
                  return [
                    _c(
                      "div",
                      { attrs: { id: "form" } },
                      [
                        _c("h2", { staticClass: "subtitle" }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t(
                                  "pages.pickup_management.closures.add_closing_date"
                                )
                              ) +
                              " : "
                          ),
                        ]),
                        _c(
                          "b-field",
                          {
                            attrs: {
                              label: _vm.$t(
                                "pages.pickup_management.closures.start_date"
                              ),
                            },
                          },
                          [
                            _c("ValidationProvider", {
                              attrs: { rules: "required", name: "start date" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function ({ errors }) {
                                      return [
                                        _c("b-datepicker", {
                                          attrs: {
                                            name: "start date",
                                            icon: "calendar-alt",
                                            placeholder: _vm.$t(
                                              "global.click_to_select"
                                            ),
                                            "date-formatter": (date) =>
                                              _vm
                                                .$dayjs(date)
                                                .format("DD/MM/YYYY"),
                                            editable: "",
                                          },
                                          model: {
                                            value: _vm.startDate,
                                            callback: function ($$v) {
                                              _vm.startDate = $$v
                                            },
                                            expression: "startDate",
                                          },
                                        }),
                                        _c(
                                          "span",
                                          { staticClass: "has-text-danger" },
                                          [_vm._v(_vm._s(errors[0]))]
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            }),
                          ],
                          1
                        ),
                        _c(
                          "b-field",
                          {
                            attrs: {
                              label: _vm.$t(
                                "pages.pickup_management.closures.end_date"
                              ),
                            },
                          },
                          [
                            _c("ValidationProvider", {
                              attrs: { rules: "required", name: "end date" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function ({ errors }) {
                                      return [
                                        _c("b-datepicker", {
                                          attrs: {
                                            name: "end date",
                                            icon: "calendar-alt",
                                            placeholder: "Click to select...",
                                            "date-formatter": (date) =>
                                              _vm
                                                .$dayjs(date)
                                                .format("DD/MM/YYYY"),
                                            editable: "",
                                          },
                                          model: {
                                            value: _vm.endDate,
                                            callback: function ($$v) {
                                              _vm.endDate = $$v
                                            },
                                            expression: "endDate",
                                          },
                                        }),
                                        _c(
                                          "span",
                                          { staticClass: "has-text-danger" },
                                          [_vm._v(_vm._s(errors[0]))]
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            }),
                          ],
                          1
                        ),
                        _c(
                          "b-field",
                          {
                            attrs: {
                              label: _vm.$t(
                                "pages.pickup_management.closures.comments"
                              ),
                            },
                          },
                          [
                            _c("ValidationProvider", [
                              _c("textarea", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.comment,
                                    expression: "comment",
                                  },
                                ],
                                staticClass: "input",
                                domProps: { value: _vm.comment },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.comment = $event.target.value
                                  },
                                },
                              }),
                            ]),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "centered-items buttons" },
                          [
                            _c(
                              "b-button",
                              {
                                staticClass: "button",
                                on: { click: _vm.close },
                              },
                              [
                                _vm._v(
                                  " " + _vm._s(_vm.$t("global.cancel")) + " "
                                ),
                              ]
                            ),
                            _c(
                              "button",
                              {
                                staticClass: "is-primary button",
                                attrs: { type: "submit" },
                              },
                              [
                                _vm._v(
                                  " " + _vm._s(_vm.$t("global.submit")) + " "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }